import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Destroy, ViewMode, NullEntity } from '@kpd/framework-ngx';
import { LicenseFacade } from 'app/shared/services/facades/license.facade';
import { LicensesNavigatorHelper } from 'app/licenses/licenses-navigator-helper';
import { License } from 'app/shared/models/license';
import { Permissions } from 'app/shared/services/permissions';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-licenses-details',
  templateUrl: './license-details.component.html',
})
export class LicenseDetailsComponent implements OnInit, OnDestroy {
  Permissions: typeof Permissions = Permissions;
  currentItem: License | NullEntity = new NullEntity();
  viewMode = ViewMode.Consult;
  tabLabels = {
    userCount: 0,
  };

  @Destroy()
  destroy$: any;

  constructor(
    public navigatorHelper: LicensesNavigatorHelper,
    public licenseFacade: LicenseFacade,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.viewMode = params['mode'];
    });
  }

  onClose(): void {
    this.navigatorHelper.back();
  }

  onItemChanged(event: License): void {
    this.currentItem = event;
    this.tabLabels.userCount = this.currentItem.quantityAssigned;
  }

  changeTabLabel(tab: string, amount: number): void {
    this.tabLabels[tab] = amount;
  }

  onSwitchMode(mode: string): void {
    this.navigatorHelper.navigateByQueryString({ tab: this.route.snapshot.queryParams['tab'], mode });
  }

  ngOnDestroy(): void {}
}
